import React from "react";

interface IProps {
    desktopSearchbox: boolean;
}
const TextSearchDummy = ({ desktopSearchbox }: IProps) =>  {

    return (
        <>
            {desktopSearchbox ?
                (<div className="textSearch-container-desktop">
                    <div>
                        <div className="input-container">
                            <div>
                                <div>
                                    <svg
                                        className="search-icon"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="-1 -1 34 34"
                                        height="20"
                                    >
                                    </svg>
                                    <input
                                        type="text"
                                        name="textSearch"
                                    />
                                    <svg
                                        className="plus-icon"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 128 128"
                                        height="20"
                                    >
                                    </svg>
                                </div>
                                <div>
                                    <span>Cancel</span>
                                </div>
                            </div>
                        </div>
                        <div className="textSearch-results-container"></div>
                    </div>
                </div>) :
                (<div className="textSearch-container">
                    <svg
                        className="search-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="-1 -1 34 34"
                        height="20"
                    >
                        <path
                            d="M21.15 19.74a12 12 0 1 0-1.41 1.41l10.55 10.56 1.41-1.41zM12 22a10 10 0 1 1 10-10 10 10 0 0 1-10 10z"/>
                    </svg>
                </div>)
            }
        </>
    );
};

export default TextSearchDummy;